export var Genders = ["Male", "Female"];
//# sourceMappingURL=IPlayer.js.map